import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  Font,
  Image,
} from '@react-pdf/renderer'
import React from 'react'
//@ts-ignore
import font from '../../assets/fonts/OpenSauceSans-Bold.ttf'
//@ts-ignore
import fontRegular from '../../assets/fonts/OpenSauceSans-Regular.ttf'
import { formatPipe, getDenomination } from '../../utils/utils'

const AuditPDF: React.FC<any> = ({ auditBody, userInfo }) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  Font.register({
    family: 'Open Sans-normal',
    fonts: [{ src: fontRegular }],
  })

  return (
    <Document title="">
      <Page size="A4" style={{ padding: 30 }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 5,
          }}
        >
          {userInfo && userInfo?.image !== ' ' && (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <Image
                src={userInfo?.image}
                style={{ objectFit: 'contain', width: 80, height: 80 }}
              />
            </View>
          )}
          <Text style={{ fontSize: 12, fontFamily: 'Open Sans' }}>
            {userInfo?.businessSocial}
          </Text>
          <Text
            style={{ fontSize: 10, marginTop: 3 }}
          >{`${userInfo?.document?.documentType}-${userInfo?.document?.document}`}</Text>
          <Text
            style={{
              fontSize: 12,
              color: '#0033A0',
              fontFamily: 'Open Sans',
              marginTop: 3,
            }}
          >
            Arqueo de Caja
          </Text>
        </View>

        <View style={{ padding: 5}}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 5,
            }}
          >
            <Text style={{ fontSize: 10, fontFamily: 'Open Sans' }}>
              Nombre del usuario:
            </Text>
            <Text style={{ fontSize: 10, marginLeft: 3 }}>
              {auditBody?.username}
            </Text>
          </View>

          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 5,
            }}
          >
            <Text style={{ fontSize: 10, fontFamily: 'Open Sans' }}>
              Fecha:
            </Text>
            <Text style={{ fontSize: 10, marginLeft: 3 }}>
              {auditBody?.date}
            </Text>
          </View>

          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 5,
            }}
          >
            <Text style={{ fontSize: 10, fontFamily: 'Open Sans' }}>Hora:</Text>
            <Text style={{ fontSize: 10, marginLeft: 3 }}>
              {auditBody?.time}
            </Text>
          </View>
        </View>

        <View style={{width: '100%', backgroundColor: "#2A5BC3", height: 1}}>
        </View>

        <View>
          { auditBody.incomeByAccount && auditBody.incomeByAccount.length > 0 && (
            <>
          <View style={{ marginTop: 15 }}>
            <Text
              style={{ fontSize: 12, fontFamily: 'Open Sans', marginBottom: 5 }}
            >
              Ingresos por cuenta
            </Text>

            <View style={{ padding: 7}}>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Nombre de la cuenta
                  </Text>
                </View>

                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Ingresos
                  </Text>
                </View>
              </View>

              {/** Aqui van los rows */}

              {auditBody.incomeByAccount?.map((v) => (
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: 5
                  }}
                >
                  <View style={{ width: '45%', textAlign: 'center' }}>
                    <Text
                      style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                    >
                      {getDenomination(v?.idCurrency)}
                    </Text>
                  </View>

                  <View style={{ width: '45%', textAlign: 'center' }}>
                    <Text
                      style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                    >
                      {formatPipe(v?.totalIncome, false, 2, -9999999999999999)}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
          <View style={{width: '100%', backgroundColor: "#2A5BC3", height: 1, marginTop: 5}}>
        </View>
            </>
          ) }


        { auditBody.incomeByCurrency && auditBody.incomeByCurrency.length > 0 && ( 
          <>
          <View style={{ marginTop: 15 }}>
            <Text
              style={{ fontSize: 12, fontFamily: 'Open Sans', marginBottom: 5 }}
            >
              Ingresos por Moneda
            </Text>

            <View style={{ padding: 7 }}>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Moneda
                  </Text>
                </View>

                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Ingresos
                  </Text>
                </View>
              </View>

              {/** Aqui van los rows */}
              {auditBody.incomeByCurrency?.map((v) => (
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginTop: 5
                  }}
                >
                  <View style={{ width: '45%', textAlign: 'center' }}>
                    <Text
                      style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                    >
                      {v?.code}
                    </Text>
                  </View>

                  <View style={{ width: '45%', textAlign: 'center' }}>
                    <Text
                      style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                    >
                      {formatPipe(v?.totalIncome, false, 2, -9999999999999999)}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
          <View style={{width: '100%', backgroundColor: "#2A5BC3", height: 1, marginTop: 5}}>
        </View>
          </>
        ) }



        {auditBody && auditBody?.cashRegisterBalance && (
          <View style={{ marginTop: 15 }}>
            <Text
              style={{ fontSize: 12, fontFamily: 'Open Sans', marginBottom: 5 }}
            >
              Balance Caja Registradora
            </Text>

            <View style={{ padding: 7 }}>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Saldo Inicial
                  </Text>
                </View>

                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{
                      color: '#0033A0',
                      fontSize: 12,
                      fontFamily: 'Open Sans',
                    }}
                  >
                    Saldo Final
                  </Text>
                </View>
              </View>

              {/** Aqui van los rows */}

              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: 10,
                }}
              >
                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                  >
                    {formatPipe(
                      auditBody?.cashRegisterBalance?.startingBalance,
                      false,
                      2,
                      -9999999999999999
                    )}
                  </Text>
                </View>

                <View style={{ width: '45%', textAlign: 'center' }}>
                  <Text
                    style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}
                  >
                    {formatPipe(
                      auditBody?.cashRegisterBalance?.endingBalance,
                      false,
                      2,
                      -9999999999999999
                    )}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        )}

        </View>
      </Page>
    </Document>
  )
}

export default AuditPDF
